import { safeParse, safeParseNullDefault } from 'shouldve-been-js';
import ObservationCustomComponentType from '../Enums/ObservationCustomComponentType';

class ObservationCustomComponentModel {

    private _sortNumber: number;
    private _caption: string;
    private _type: ObservationCustomComponentType;
    private _options: string[];
    private _defaultValue: string;
    private _itemEnableMask: boolean[];

    public constructor(sortNumber: number, caption: string, type: ObservationCustomComponentType, options: string[], defaultValue: string, itemEnableMask: boolean[]) {

        this._sortNumber = sortNumber;
        this._caption = caption;
        this._type = type;
        this._options = options;
        this._defaultValue = defaultValue;
        this._itemEnableMask = itemEnableMask;
    }

    public get sortNumber(): number {
        return this._sortNumber;
    }

    public set sortNumber(value: number) {
        this._sortNumber = value;
    }

    public get caption(): string {
        return this._caption;
    }

    public set caption(value: string) {
        this._caption = value;
    }

    public get type(): ObservationCustomComponentType {
        return this._type;
    }

    public set type(value: ObservationCustomComponentType) {
        this._type = value;
    }

    public get options(): string[] {
        return this._options;
    }

    public set options(value: string[]) {
        this._options = value;
    }

    public get defaultValue(): string {
        return this._defaultValue;
    }

    public set defaultValue(value: string) {
        this._defaultValue = value;
    }

    public get itemEnableMask(): boolean[] {
        return this._itemEnableMask;
    }

    public set itemEnableMask(value: boolean[]) {
        this._itemEnableMask = value;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromJson(json: any): ObservationCustomComponentModel | null {

        const sortNumber: number | null = safeParseNullDefault<number>(json?.sortNumber, 0);
        const caption: string = safeParse<string>(json?.caption, '');
        const typeString: string | null = safeParseNullDefault<string>(json?.type, '');
        const optionsString: string = safeParse<string>(json?.options, '');
        const defaultValue: string = safeParse<string>(json?.default, '');
        const itemEnableMaskString: string = safeParse<string>(json?.itemEnableMask, '');

        let type: ObservationCustomComponentType | null = null;
        if (typeString === 'Combo') {
            type = ObservationCustomComponentType.COMBO;
        } else if (typeString === 'Date') {
            type = ObservationCustomComponentType.DATE;
        }

        const options: string[] = optionsString.split(';');
        const itemEnableMask: boolean[] = itemEnableMaskString === '' ? [] : itemEnableMaskString.split(';').map((value: string) => value === '1');
        
        if (sortNumber === null || type === null) {
            return null;
        }

        return new ObservationCustomComponentModel(sortNumber, caption, type, options, defaultValue, itemEnableMask);
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromIndexedDB(object: any): ObservationCustomComponentModel | null {

        const sortNumber: number | null = safeParseNullDefault<number>(object?._sortNumber, 0);
        const caption: string = safeParse<string>(object?._caption, '');
        const typeNumber: number | null = safeParseNullDefault<number>(object?._type, 0);
        const defaultValue: string = safeParse<string>(object?._defaultValue, '');

        let type: ObservationCustomComponentType | null = null;
        if (typeNumber === 0) {
            type = ObservationCustomComponentType.COMBO;
        } else if (typeNumber === 1) {
            type = ObservationCustomComponentType.DATE;
        }

        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const options: string[] = object?._options;

        if (!Array.isArray(options)) {
            return null;
        }

        if (!options.every((option: string) => typeof option === 'string')) {
            return null;
        }

        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const itemEnableMask: boolean[] = object?._itemEnableMask;

        if (!Array.isArray(itemEnableMask)) {
            return null;
        }

        if (!itemEnableMask.every((value: boolean) => typeof value === 'boolean')) {
            return null;
        }
        
        if (sortNumber === null || type === null) {
            return null;
        }

        return new ObservationCustomComponentModel(sortNumber, caption, type, options, defaultValue, itemEnableMask);
    }
}

export default ObservationCustomComponentModel;